// Keeps pins clear of the stage edges, matching Content Factory's own
// placement range.
const PIN_MIN = 0.15;
const PIN_SPAN = 0.7;

/**
 * Hotspots authored without an image carry no x/y, so the placeholder has to
 * invent them. Deliberately derived from the hotspot rather than Math.random:
 * opening a hotspot re-renders this component, and a fresh roll each time
 * would make every pin jump on click. Hashing also means the layout is the
 * same on every reload and for every learner, so a screenshot in a bug report
 * matches what the reporter saw. Content Factory can afford Math.random
 * because it persists the result; nothing is persisted here.
 */
export const generatedCoordinate = (seed: string, salt: number) => {
  let hash = salt;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) % 100_000;
  }

  return PIN_MIN + ((hash % 1000) / 1000) * PIN_SPAN;
};
